import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core'
import { fromEvent, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'lin-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss'],
  standalone: false,
})
export class ImportFileComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>

  @Input() title: string
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() reset = new EventEmitter<() => void>()
  @Output() importFile = new EventEmitter<File>()

  private readonly onDestroy$ = new Subject<void>()

  ngOnInit(): void {
    const fileInput = this.fileInput.nativeElement

    fromEvent(fileInput, 'click')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.clearFileName()
        this.reset.next(undefined)
      })

    fromEvent(fileInput, 'change')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => this.importFile.next(fileInput.files[0]))
  }

  clearFileName() {
    this.fileInput.nativeElement.value = ''
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
